import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
} from 'antd';
import i18n from '../../../config/i18n';
import {
  REGEX_EMAIL,
  REGEX_PHONE,
} from '../../../toolbox/regex';
import '../../../styles/css/RequestDemo.css';

const i18nScope = 'requestDemo';

const rangeOfProviders = [
  '1',
  '2-5',
  '6-10',
  '11-20',
  '21-50',
  '51-100',
  '100+',
];

const formFields = [
  {
    id: 'firstName',
    label: i18n.t('firstName'),
    options: {
      initialValue: '',
      rules: [{ required: true, message: ' ' }],
    },
    span: 10,
    children: <Input />,
  },
  {
    id: 'lastName',
    label: i18n.t('lastName'),
    options: {
      initialValue: '',
      rules: [{ required: true, message: ' ' }],
    },
    offset: 4,
    span: 10,
    children: <Input />,
  },
  {
    id: 'email',
    label: i18n.t('email'),
    options: {
      initialValue: '',
      rules: [
        { required: true, message: ' ' },
        { pattern: REGEX_EMAIL, message: 'Invalid email.' },
      ],
    },
    children: <Input />,
  },
  {
    id: 'practiceOrCompany',
    label: i18n.t([i18nScope, 'practiceOrCompany']),
    options: {
      initialValue: '',
      rules: [{ required: true, message: ' ' }],
    },
    children: <Input />,
  },
  {
    id: 'title',
    label: i18n.t('title'),
    options: {
      initialValue: '',
      rules: [{ required: true, message: ' ' }],
    },
    children: <Input />,
  },
  {
    id: 'aboutPractice',
    label: i18n.t([i18nScope, 'aboutPractice']),
    options: {
      initialValue: '',
      rules: [{ required: true, message: ' ' }],
    },
    children: (
      <Select>
        {
          /**
           * Note:
           * The tricky part is that the first range is 1 so that we can tell i18n to use
           * singular or plural word by assigning "index + 1" to "count".
           */
        }
        {
          rangeOfProviders.map((range, index) => {
            const text = i18n.t([i18nScope, 'provider'], { count: index + 1, range });
            return (
              <Select.Option
                key={range}
                value={text}
              >
                {text}
              </Select.Option>
            );
          })
        }
      </Select>
    ),
  },
  {
    id: 'phoneNumber',
    label: i18n.t('phoneNumber'),
    options: {
      initialValue: '',
      rules: [
        { required: true, message: ' ' },
        { pattern: REGEX_PHONE, message: 'Invalid phone number.' },
      ],
    },
    children: <Input />,
  },
  {
    id: 'message',
    label: i18n.t([i18nScope, 'message']),
    options: {
      initialValue: '',
      rules: [],
    },
    children: <Input.TextArea />,
  },
];


const RequestDemo = ({
  form: {
    getFieldDecorator,
    getFieldsValue,
    resetFields,
    validateFieldsAndScroll,
  },
  onSubmit,
}) => {
  const generateFormItem = data => data.map(({
    id,
    label,
    options,
    offset = 0,
    span = 24,
    children,
  }) => (
    <Col
      key={id}
      offset={offset}
      span={span}
    >
      <Form.Item
        className="init-label-line-height"
        label={label}
      >
        {getFieldDecorator(id, options)(children)}
      </Form.Item>
    </Col>
  ));

  const onSubmitClick = () => {
    // validate all fields.
    validateFieldsAndScroll(
      { scroll: { offsetTop: 120 } },
      (errors) => {
        if (!errors) {
          onSubmit(getFieldsValue());
          resetFields();
        }
      }
    );
  };

  return (
    <Form>
      <div className="request-demo-form-title-wrapper">
        <h1 className="request-demo-form-title">
          {i18n.t([i18nScope, 'title'])}
        </h1>
        <h5 className="request-demo-form-subtitle">
          {i18n.t([i18nScope, 'subtitle'])}
        </h5>
      </div>
      <Row>
        {generateFormItem(formFields)}
      </Row>
      <Form.Item className="request-demo-form-submit-button-wrapper">
        <Button
          className="request-demo-form-submit-button"
          onClick={onSubmitClick}
          type="primary"
        >
          {i18n.t('submit')}
        </Button>
      </Form.Item>
    </Form>
  );
};

RequestDemo.propTypes = {
  form: PropTypes.shape({
    getFieldDecorator: PropTypes.func.isRequired,
    getFieldsValue: PropTypes.func.isRequired,
    resetFields: PropTypes.func.isRequired,
    validateFieldsAndScroll: PropTypes.func.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

RequestDemo.defaultProps = {};

export default Form.create()(RequestDemo);



// WEBPACK FOOTER //
// ./src/components/landing/HeroBanner/RequestDemo.js